var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBnbIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.11582 8.40416L9.99996 4.52L13.8859 8.40584L16.1459 6.14584L9.99996 0L3.85598 6.144L6.1159 8.404L6.11582 8.40416ZM0 10L2.26007 7.7396L4.51998 9.99952L2.25991 12.2596L0 10ZM6.11582 11.5961L9.99996 15.48L13.8859 11.5942L16.1471 13.853L16.1459 13.8542L9.99996 20L3.85598 13.856L3.85278 13.8528L6.11606 11.5958L6.11582 11.5961ZM15.4799 10.001L17.74 7.74088L19.9999 10.0008L17.7399 12.2609L15.4799 10.001Z",
    fill: "#F3BA2F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2917 9.9989H12.2927L9.99955 7.70557L8.3046 9.40008L8.10988 9.59489L7.70828 9.99658L7.70508 9.9997L7.70828 10.003L9.99955 12.2946L12.2928 10.0013L12.2939 10L12.2919 9.9989",
    fill: "#F3BA2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnbIcon);
export default __webpack_public_path__ + "static/media/bnbIcon.07ec834df45f79b95c3e6f6dd35ff2d5.svg";
export { ForwardRef as ReactComponent };